import { CALENDAR_ITEM_KIND_VARIANT } from '../../Calendar.constants'
import {
  getCalendarRequestLabel,
  getIsCalendarFollowUpMovable,
} from '../../Calendar.utils'

import {
  getCalendarCardPeople,
  getCalendarDetailsLabel,
  getCalendarKindLabel,
  getCalendarPeopleLabel,
} from './useCalendarItemsLoader.utils.labels'

export function toCalendarGridFollowUp(
  { assignees, can_edit: canEdit, date, id, is_due: isDue, kind, request },
  t
) {
  const isArchived = request.is_archived

  return {
    assigneeIds: assignees.map(person => person.id),
    canEdit,
    card: {
      address: request.address,
      people: getCalendarCardPeople(assignees),
      title: getCalendarRequestLabel(request),
    },
    chip: { title: t('Calendar.FollowUpSingularKey') },
    date,
    id,
    isAllDay: true,
    isArchived,
    isCountedInDayLoad: true,
    isDraggable: getIsCalendarFollowUpMovable({ canEdit, isArchived }),
    isDue,
    kind,
    popover: {
      kindLabel: getCalendarKindLabel({ kind, t }),
      secondaryLabel: getCalendarDetailsLabel({ people: assignees, request }),
    },
    requestId: request.id,
    secondaryLabel: getCalendarPeopleLabel(assignees),
    title: getCalendarRequestLabel(request),
    url: request.url,
    variant: CALENDAR_ITEM_KIND_VARIANT[kind],
  }
}

// TODO: align the follow_up_day fields with CAL-01 §11.1 once the spec lists
// them (TM-01-08).
export function toCalendarGridFollowUpDay({ count, date, id, items, kind }, t) {
  return {
    aggregatedItems: items.map(item => toCalendarGridFollowUp(item, t)),
    date,
    id,
    isAllDay: true,
    isCountedInDayLoad: true,
    kind,
    opensDayPopover: true,
    title: t('Calendar.FollowUpsChipKey', { count }),
    variant: CALENDAR_ITEM_KIND_VARIANT[kind],
  }
}
